class Contact {

    constructor() {
        this.$form = null;
    }

    getForm() {
        if (!this.$form || !this.$form.length) {
            this.$form = $('#contact_form');
        }
        return this.$form;
    }

    success(data) {
        this.getForm()[0].reset();
        $("#flash").html('<div class="alert alert-success">'+data['message']+'</div>');
    }

    error() {
        console.log('error');
        $("#flash").html('<div class="alert alert-danger">Problème lors de l\'envoi du formulaire</div>');
    }
}

export default new Contact();